/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Refusal_MisconfiguredInputs */



/**
* | output |
* | --- |
* | "This app asked for data it is not set up to read. It needs a change from whoever built it before this part will work." |
*
* @param {Canvas_Refusal_MisconfiguredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_refusal_misconfigured = /** @type {((inputs?: Canvas_Refusal_MisconfiguredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Refusal_MisconfiguredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese App hat Daten angefragt, für die sie nicht eingerichtet ist. Dieser Teil funktioniert erst, wenn die Person, die die App erstellt hat, das anpasst.")
	return /** @type {LocalizedString} */ ("This app asked for data it is not set up to read. It needs a change from whoever built it before this part will work.")
});